import { limitOrderFormApiConnector } from 'apiConnector/secondary-market/limit-order/form';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { limitOrderInputFormActions } from 'state/secondaryMarket/limit-order/form/input/inputForm.actions';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';
import { extractHttpErrorMessage } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function fetchLimitOrderSettlementDateEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { getSettlementDate } = limitOrderFormApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_SETTLEMENT_DATE_REQUESTED'),
      mergeMap(({ tabId, bcsProductKey, counterpartyEliotId, clientType }) => {
        return getSettlementDate(bcsProductKey, counterpartyEliotId, clientType).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          map(data => limitOrderInputFormActions.settlementDateReceived(tabId, data.settlementDate)),
          catchError((err: HttpError) => {
            return of(
              limitOrderInputFormActions.settlementDateRequestFailed(
                tabId,
                bcsProductKey,
                extractHttpErrorMessage(err, { backend: 'domino' })!,
              ),
            );
          }),
        );
      }),
    );
  };
}
